import { ComponentProps } from 'react'
import { cn } from '~utils/cn'

export type ProgressBarProps = Readonly<
  ComponentProps<'div'> & {
    total: number
    currentStep: number
    // segmented: 단계마다 한 칸 (기본), continuous: 트랙 하나에 비율만큼 채움 (단계가 많을 때)
    variant?: 'segmented' | 'continuous'
  }
>

const ProgressBar = ({ total, currentStep, variant = 'segmented', ...props }: ProgressBarProps) => {
  const { className } = props

  if (variant === 'continuous') {
    const ratio = total > 0 ? Math.min(Math.max(currentStep / total, 0), 1) : 0
    return (
      <div
        className={cn(
          'h-1 w-full overflow-hidden rounded-full',
          'bg-primary-100 dark:bg-gray-700',
          className
        )}
      >
        <div
          className="h-full rounded-full bg-primary-500 dark:bg-primary-400 transition-all duration-300"
          style={{ width: `${ratio * 100}%` }}
        />
      </div>
    )
  }

  return (
    <div className="flex w-full justify-between flex-gap-x-1">
      {[...Array(total).keys()].map(index => {
        const step = index + 1
        return (
          <div
            className={cn(
              'h-1 w-full overflow-hidden rounded-xl',
              'bg-gray-100 dark:bg-gray-700',
              className
            )}
            key={step}
          >
            <div
              className={cn(
                'h-full bg-primary-500 dark:bg-primary-400 transition-all duration-300',
                currentStep >= step ? 'w-full' : 'w-0'
              )}
              key={step}
            />
          </div>
        )
      })}
    </div>
  )
}

export default ProgressBar
